import { Icon, Tooltip, TooltipContent, TooltipTrigger } from "@elit-hair/elit-ui";
import { motion } from "framer-motion";
import { t } from "i18next";
import { TbTrash, TbX } from "react-icons/tb";

import chatIcon from "@/assets/darwin-robot.svg";
import { cn } from "@/lib/utils";
import { buttonHover, fadeIn } from "@/utils/animations";

type ChatHeaderProps = {
    onClose?: () => void;
    onClearHistory?: () => void;
    className?: string;
};

export function ChatHeader({ onClose, onClearHistory, className }: ChatHeaderProps) {
    return (
        <motion.div
            className={cn(
                "flex items-center justify-between p-4",
                "border-b border-gray-200/50 dark:border-white/10",
                className
            )}
            {...fadeIn}
            transition={{ duration: 0.2 }}
        >
            <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-muted dark:bg-gray-300 border border-gray-200/50 dark:border-white/10 from-blue-500 via-purple-600 to-pink-500 rounded-lg flex items-center justify-center">
                    <img src={chatIcon} alt="Chat-Icon" className="w-8 h-8" />
                </div>
                <div>
                    <h3 className="font-semibold text-gray-900 dark:text-white text-sm">{t("darwin")}</h3>
                    <p className="text-xs text-gray-500 dark:text-white/60">{t("how_can_i_help_you")}</p>
                </div>
            </div>

            <div className="flex items-center gap-1">
                {/* Clear History Button */}
                <Tooltip>
                    <TooltipTrigger asChild>
                        <motion.button
                            {...buttonHover}
                            onClick={onClearHistory}
                            className="p-1.5 hover:bg-gray-100 dark:hover:bg-white/10 rounded-lg transition-colors group"
                        >
                            <TbTrash className="w-4 h-4 text-gray-600 dark:text-white/70 group-hover:text-red-500 transition-colors" />
                        </motion.button>
                    </TooltipTrigger>
                    <TooltipContent>{t("clear_chat_history")}</TooltipContent>
                </Tooltip>

                {/* Close Button */}
                <Tooltip>
                    <TooltipTrigger asChild>
                        <motion.button
                            {...buttonHover}
                            onClick={onClose}
                            className="p-1.5 hover:bg-gray-100 dark:hover:bg-white/10 rounded-lg transition-colors"
                        >
                            <Icon icon={TbX} className="w-4 h-4 text-gray-600 dark:text-white/70" />
                        </motion.button>
                    </TooltipTrigger>
                    <TooltipContent>{t("close")}</TooltipContent>
                </Tooltip>
            </div>
        </motion.div>
    );
}
